(function () {
  'use strict';

  angular
    .module('itecAdministracio.usuaris.main.submain.edit')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('usuaris.main.submain.edit', {
        url: '/edit',
         params: {
          isNew : false
        },
      views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: function(permisosUsuarisHeaderSubmenuLinksValue){
                return permisosUsuarisHeaderSubmenuLinksValue;
              }
            }
          },
          'content@usuaris.main.submain': {
            templateUrl: 'usuaris/main/edit/edit.tpl.html',
            controller: 'UsuarisMainEditCtrl',
            controllerAs: 'ctrl'  ,
            resolve: {
              llistaproductes:function(ProducteBotigaFactory) {
                return ProducteBotigaFactory.getProductesBotigaEntitats().catch(function(){});
              },
              llistarols: function(RolFactory) {
                return RolFactory.getAll().catch(function(){});
              },
              llistaentitats:function(EntitatFactory) {
                return EntitatFactory.getAll().catch(function(){});
              },
              usuariData: function(UsuariFactory, $stateParams) {
                if ($stateParams.isNew){
                  return {};
                }
                else if (!angular.isUndefined($stateParams.idUsuari)
                          && $stateParams.idUsuari !== null
                          && $stateParams.idUsuari) {
                  return UsuariFactory.get($stateParams.idUsuari).catch(function(){});
                }
                else {
                  return {};
                }
              }
            }
          }
        }
      });
  }
}());
